import { fetchPageById, fetchDescendantsWithSpecificContentType } from "../../UmbracoContentDeliveryApiUtils";
import { ILoadedNewsListingBlockData } from "./news-listing-block-types";
function getJustNewsListingBlocks(anArrayOfBlocks) {
    return anArrayOfBlocks.filter(aBlock => aBlock.content.contentType === "newsListingBlock");
}
function extractNecessaryPropertiesFromNewsListingBlocks(newsListingBlocks, newsListingBlockId: string): Array<ILoadedNewsListingBlockData> {

    return newsListingBlocks.map((aNewsListingBlock) => {
        //console.log("a news listing block, pre-extraction: ", aNewsListingBlock);
        if (aNewsListingBlock.content.id !== newsListingBlockId) {
            //for cases when a page has multiple news listing blocks
            //console.log("no match")
            return;
        }
        else {
            return {
                heading: aNewsListingBlock.content.properties.heading,
                icon: aNewsListingBlock.content.properties.icon,
                featuredStories: aNewsListingBlock.content.properties.featuredStories,
                overrideFeaturedStories: aNewsListingBlock.content.properties.overrideFeaturedStories,
                alignment: aNewsListingBlock.content.properties.alignment,
                colour: aNewsListingBlock.content.properties.colour,
            }
        }
    }).filter((aBlock) => aBlock);

}

function extractNecessaryPropertiesFromEachNewsItem(newsItems) {
    return newsItems.map((newsItem) => {
        return {
            id: newsItem.id,
            name: newsItem.properties.articleHeroHeading,
            summary: newsItem.properties.introText,
            media: newsItem.properties.articleHeroImage || newsItem.properties.shareImage,
            url: newsItem.route.path,
            author: newsItem.properties.author?.map(author => {
                return {
                    id: author.id,
                    name: author.name,
                }
            }),
            publicationDate: newsItem.properties.publicationDate != null ? new Date(newsItem.properties.publicationDate) : new Date(newsItem.createDate)
        }
    });
}

async function handleFeaturedStories(aNewsListingBlock): Promise<ILoadedNewsListingBlockData | void> {
    if (!aNewsListingBlock?.overrideFeaturedStories) {
        //if no override Featured Stories are set
        //console.log("no override Featured Stories are set");
        const pageId = aNewsListingBlock.featuredStories[0].id;
        const theSelectedNewsListingPage = await fetchDescendantsWithSpecificContentType(pageId, 5, "newsPage");
        //console.log("the selected news listing page", theSelectedNewsListingPage);
        const theActualFeaturedStories = extractNecessaryPropertiesFromEachNewsItem(theSelectedNewsListingPage.items);
        aNewsListingBlock.featuredStories = theActualFeaturedStories;
        //console.log("the updated news listing block properties", aNewsListingBlock);
        return aNewsListingBlock;
    }
    else {
        //if override Featured Stories ARE set, write them onto the featured stories property and return that
        //console.log("override Featured Stories ARE set");
        const theActualFeaturedStories = extractNecessaryPropertiesFromEachNewsItem(aNewsListingBlock.overrideFeaturedStories.slice(0, 5));
        aNewsListingBlock.featuredStories = theActualFeaturedStories;
        //console.log("the updated news listing block properties", aNewsListingBlock);
        return aNewsListingBlock;
    }
}

async function doEverything(pageId: string, blockId: string): Promise<ILoadedNewsListingBlockData | void> {
    const thePageThisNewsListingBlockIsOn = await fetchPageById(pageId);
    const justTheNewsListingBlocks = getJustNewsListingBlocks(thePageThisNewsListingBlockIsOn.properties.blockList.items)
    //console.log("justTheNewsListingBlocks", justTheNewsListingBlocks);
    const interimObject = extractNecessaryPropertiesFromNewsListingBlocks(justTheNewsListingBlocks, blockId);
    //console.log("interim object", interimObject);
    const finalObject = await handleFeaturedStories(interimObject[0]);
    //console.log("finalObject", finalObject);
    return finalObject;
}

export { doEverything };